import { MapContainer, TileLayer, Polygon, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const SERVICE_BOUNDARY = [
  [-27.165, 153.005],
  [-27.17, 153.04],
  [-27.183, 153.065],
  [-27.19, 153.088],
  [-27.205, 153.1],
  [-27.228, 153.098],
  [-27.248, 153.085],
  [-27.258, 153.062],
  [-27.275, 153.048],
  [-27.29, 153.028],
  [-27.295, 153.002],
  [-27.286, 152.978],
  [-27.265, 152.963],
  [-27.242, 152.955],
  [-27.22, 152.955],
  [-27.198, 152.964],
  [-27.18, 152.98],
  [-27.169, 152.993],
];

export const ServiceAreaMap = () => (
  <div className="relative aspect-square rounded-3xl overflow-hidden border border-white/10" data-testid="service-area-map">
    <MapContainer
      center={[-27.228, 153.028]}
      zoom={12}
      scrollWheelZoom={false}
      className="w-full h-full z-0"
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Polygon
        positions={SERVICE_BOUNDARY}
        pathOptions={{ color: "#e11d48", weight: 3, fillColor: "#e11d48", fillOpacity: 0.08, lineJoin: "round", lineCap: "round", smoothFactor: 1.5 }}
      >
        <Tooltip sticky>CBA Mowing service area</Tooltip>
      </Polygon>
    </MapContainer>
    <div className="absolute bottom-4 left-4 z-[400] font-mono-t text-[10px] uppercase tracking-widest bg-[#0B0F0C]/80 text-white px-3 py-1.5 rounded-full pointer-events-none">
      Moreton Bay service area
    </div>
  </div>
);
